var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImacFrameV2 = function SvgImacFrameV2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475.896,
    height: 509.111,
    viewBox: "0 0 475.896 509.111",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.21,
    y1: 0.5,
    x2: 0.3,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#6f6d6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cacaca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.496,
    y1: 1.017,
    x2: 0.519,
    y2: -0.131,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.21,
    y1: 0.5,
    x2: 0.3,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.498,
    y1: 0.846,
    x2: 0.505,
    y2: -0.299,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.5,
    y1: -1.381,
    x2: 0.5,
    y2: 1.879,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cacaca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 1.275,
    y1: 0.501,
    x2: -0.901,
    y2: 0.497,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.592,
    y1: 0.682,
    x2: 0.199,
    y2: -0.078,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -0.383,
    y1: -0.109,
    x2: 1.513,
    y2: 1.199,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 1.122,
    y1: 0.094,
    x2: 0.498,
    y2: 0.562,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.249,
    cy: 24.094,
    rx: 172.249,
    ry: 24.094,
    transform: "translate(73.637 460.923)",
    fill: "rgba(255,255,255,0)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M522.966,567.755s8.129,26.77,10.205,35.208,5.306,23.156-12.508,29.717a189.875,189.875,0,0,1-25.021,6.824,76.071,76.071,0,0,1-15.392,1.739c-3.979,0-104.167-3.346-109.355-3.745s-8.3-4.419-2.538-4.021c5.019.353,78.8-.4,97.309-11.839S520.2,588.839,522.966,567.755Z",
    transform: "translate(-264.975 -150.071)",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M524.61,569.741s3.333,10.491,8.3,28.916c5.016,18.6,1.408,27.625-16.6,32.657a208.8,208.8,0,0,1-23.406,4.618l-117.486-.716a20.674,20.674,0,0,1-5.157-.657c-2.1-.672.26-1.306,3.678-1.986,14.616-2.9,36.455-2.887,49.442-6.612,19.6-5.619,22.136-14.19,20.061-28.646a261.551,261.551,0,0,0-5.535-27.3Z",
    transform: "translate(-269.038 -149.91)",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.1,610.484a16.162,16.162,0,0,0,.708-1.72l91.455,4.84c-1.7,7.069-7.288,11.535-18.071,14.546a208.782,208.782,0,0,1-23.406,4.618l-45.684-.278C376.8,619.688,372.854,613.283,370.1,610.484Z",
    transform: "translate(-196.926 -146.746)",
    fill: "url(#c)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.617,577.26c-1-4.411-1.762-7.25-1.762-7.25l86.7-.269s1.3,4.087,3.482,11.641Z",
    transform: "translate(-207.987 -149.91)",
    opacity: 0.4,
    fill: "url(#d)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.871,272.975a18.666,18.666,0,0,1,3.735-10.1,14.394,14.394,0,0,1,8.231-5.419l411.6-75.865c3.2-.1,8.647,2.008,14.064,8.668a23.934,23.934,0,0,1,5.28,15.528L584.154,597.137a21.294,21.294,0,0,1-5.686,13.49,15.836,15.836,0,0,1-12.164,5.1l-413.66-18.394a8.553,8.553,0,0,1-6.4-3.507,11.554,11.554,0,0,1-2.243-7.785Z",
    transform: "translate(-132.908 -181.381)",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.763,272.99a18.658,18.658,0,0,1,3.734-10.1,14.391,14.391,0,0,1,8.231-5.419l421.565-75.91a7.13,7.13,0,0,1,6.737,2.136,9.945,9.945,0,0,1,2.643,7.506L596.045,597.153a21.3,21.3,0,0,1-5.685,13.49,15.842,15.842,0,0,1-12.166,5.1L164.536,597.352a8.551,8.551,0,0,1-6.4-3.507,11.563,11.563,0,0,1-2.243-7.785Z",
    transform: "translate(-155.867 -181.396)",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.867,545.074,174.88,272.99a18.657,18.657,0,0,1,3.734-10.1,14.391,14.391,0,0,1,8.231-5.419l421.565-75.91a7.13,7.13,0,0,1,6.737,2.136,9.945,9.945,0,0,1,2.643,7.506L596.282,548.722Z",
    transform: "translate(-152.985 -181.396)",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M603.859,203.23,583.107,523.424l-407.68.532,19.5-250.512Z",
    transform: "translate(-157.247 -179.626)",
    fill: "url(#h)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M367.336,268.379a18.657,18.657,0,0,1,3.734-10.1,14.391,14.391,0,0,1,8.231-5.419l81.013-14.586L633.746,605.172,354.109,592.74a8.551,8.551,0,0,1-6.4-3.507,11.563,11.563,0,0,1-2.243-7.785Z",
    transform: "translate(-345.44 -176.785)",
    fill: "url(#i)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImacFrameV2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/imac-frame-v2.3a338838.svg";
export { ForwardRef as ReactComponent };